import { render, staticRenderFns } from "./ModrAddMain.vue?vue&type=template&id=453c18a8&scoped=true&"
import script from "./ModrAddMain.vue?vue&type=script&lang=js&"
export * from "./ModrAddMain.vue?vue&type=script&lang=js&"
import style0 from "./ModrAddMain.vue?vue&type=style&index=0&id=453c18a8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453c18a8",
  null
  
)

export default component.exports